module.exports = __webpack_public_path__ + "static/media/EllipseCirclePay.1a5f09c2.png";